/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSkillSuggestionFeedbackSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillSuggestionFeedbackSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillSuggestionFeedbackSecurity = {
  option1?: ListSkillSuggestionFeedbackSecurityOption1 | undefined;
  option2?: ListSkillSuggestionFeedbackSecurityOption2 | undefined;
};

export type ListSkillSuggestionFeedbackRequest = {
  /**
   * The proposed change ID.
   */
  id: string;
  /**
   * The number of feedback records to return.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSkillSuggestionFeedbackSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillSuggestionFeedbackSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListSkillSuggestionFeedbackSecurityOption1$Outbound,
    ListSkillSuggestionFeedbackSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listSkillSuggestionFeedbackSecurityOption1ToJSON(
  listSkillSuggestionFeedbackSecurityOption1:
    ListSkillSuggestionFeedbackSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillSuggestionFeedbackSecurityOption1$outboundSchema.parse(
      listSkillSuggestionFeedbackSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionFeedbackSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillSuggestionFeedbackSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListSkillSuggestionFeedbackSecurityOption2$Outbound,
    ListSkillSuggestionFeedbackSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listSkillSuggestionFeedbackSecurityOption2ToJSON(
  listSkillSuggestionFeedbackSecurityOption2:
    ListSkillSuggestionFeedbackSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillSuggestionFeedbackSecurityOption2$outboundSchema.parse(
      listSkillSuggestionFeedbackSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionFeedbackSecurity$Outbound = {
  Option1?: ListSkillSuggestionFeedbackSecurityOption1$Outbound | undefined;
  Option2?: ListSkillSuggestionFeedbackSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillSuggestionFeedbackSecurity$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionFeedbackSecurity$Outbound,
  ListSkillSuggestionFeedbackSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillSuggestionFeedbackSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillSuggestionFeedbackSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillSuggestionFeedbackSecurityToJSON(
  listSkillSuggestionFeedbackSecurity: ListSkillSuggestionFeedbackSecurity,
): string {
  return JSON.stringify(
    ListSkillSuggestionFeedbackSecurity$outboundSchema.parse(
      listSkillSuggestionFeedbackSecurity,
    ),
  );
}

/** @internal */
export type ListSkillSuggestionFeedbackRequest$Outbound = {
  id: string;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillSuggestionFeedbackRequest$outboundSchema: z.ZodMiniType<
  ListSkillSuggestionFeedbackRequest$Outbound,
  ListSkillSuggestionFeedbackRequest
> = z.pipe(
  z.object({
    id: z.string(),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillSuggestionFeedbackRequestToJSON(
  listSkillSuggestionFeedbackRequest: ListSkillSuggestionFeedbackRequest,
): string {
  return JSON.stringify(
    ListSkillSuggestionFeedbackRequest$outboundSchema.parse(
      listSkillSuggestionFeedbackRequest,
    ),
  );
}
